import React, { Component } from "react";
import Button from "./Button";
import DropdownButton from "./DropdownButton";
import Icon from "./Icon";
import Moment from "./Moment";
import styles from "./ImageListItem.module.css";

export default class ImageListItem extends Component {
  constructor(props) {
    super(props);
    this.onDelete = this.onDelete.bind(this);
  }

  onDelete() {
    const { id } = this.props.email;
    this.props.onDelete(id);
  }

  render() {
    const { id, name, updatedAt, updatedByName, EmailTemplate } =
      this.props.email;
    const { accountId } = this.props;

    return (
      <tr>
        <td style={{ width: "200px" }} onClick={this.handleClick}>
          <div className={styles.preview}>
            <img
              src={`${process.env.REACT_APP_API_ENDPOINT}/api/clients/${accountId}/images/${id}/image?updatedAt=${updatedAt}`}
              alt=""
            />
          </div>
        </td>
        <td style={{ width: "300px" }} onClick={this.handleClick}>
          {name}
        </td>
        <td
          onClick={this.handleClick}
        >{`${process.env.REACT_APP_API_ENDPOINT}/api/clients/${accountId}/images/${id}/image`}</td>
        <td onClick={this.handleClick}>
          {EmailTemplate && EmailTemplate.name}
        </td>
        <td style={{ width: "300px" }} onClick={this.handleClick}>
          {updatedByName}
        </td>
        <td style={{ width: "300px" }}>
          <Moment date={updatedAt} />
        </td>
        <td style={{ width: "400px", textAlign: "right" }}>
          <a
            href={`${process.env.REACT_APP_API_ENDPOINT}/api/clients/${accountId}/images/${id}/image?updatedAt=${updatedAt}`}
            download={name}
          >
            <Button type="link" title="Download">
              <Icon icon="download" />
            </Button>
          </a>
          <DropdownButton
            type="link"
            pin="right"
            options={[
              {
                label: "Delete",
                onClick: this.onDelete,
              },
            ]}
          />
        </td>
      </tr>
    );
  }
}
